<template>
<div>
  <Grid name="filterGridZone" ref="filterGridZone" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"  v-bind:databound="dataBound"></Grid>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'Zone',
  extends: BaseFilter,
  components: {
    Grid
  },
  data() {
    return {
      fieldName: 'zone',
      fieldLabel: 'Zona',
      gridRef: 'filterGridZone',
      preload: [{
        field: 'dealer_id',
        api: 'dealers/lst'
      }],
      schemaModelFields: {},
      url: 'zones',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        field: 'zone',
        title: 'Zona',
        width: '200px'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// ZonesFilter.vue?29acdb37